var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsAssistiveTechnology(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hfwnrp23sa"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#hfwnrp23sa)",
    transform: "translate(-486 -2332) translate(0 2170) translate(360 67) translate(0 85)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M9.076 0C7.962 0 7.06.895 7.06 2s.903 2 2.017 2c1.114 0 2.017-.895 2.017-2s-.903-2-2.017-2zM8.068 6C6.953 6 6.05 6.895 6.05 8v4c0 1.105.902 2 2.017 2h4.471l2.732 4.514L17 17.486l-3.025-5c-.182-.301-.51-.486-.865-.486h-2.017V8c0-1.105-.903-2-2.017-2H8.068zM4.034 8.35C1.687 9.176 0 11.393 0 14c0 3.309 2.714 6 6.05 6 2.63 0 4.866-1.673 5.699-4H9.523c-.7 1.19-1.986 2-3.472 2-2.225 0-4.034-1.794-4.034-4 0-1.474.817-2.75 2.017-3.443V8.35z",
    transform: "translate(126 10)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAssistiveTechnology);
export default __webpack_public_path__ + "static/media/icons-assistive-technology.a27dfddc5f40b34c3e7619f9349c1934.svg";
export { ForwardRef as ReactComponent };